import { Card, Checkbox, Typography } from '@mui/material';
import { GridColDef, GridFilterItem, GridFilterModel, GridLinkOperator, useGridApiRef } from '@mui/x-data-grid-pro';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useGetInfiniteItems, useToggleLeadSprint } from '../../../../hooks/sprint-leads.hooks';
import { LeadGridItem } from '../../../../types/Lead';
import { Filter } from '../../../filters/FilterTypes';
import LeadDataGridView2 from '../../../Components/LeadDataGridView2';
import { IdealCustomerProfile } from '../types/IdealCustomerProfile';
import useICPWizard from '../hooks/useICPWizard';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import { Sprint } from '../../../../stores/SprintStore';
import React from 'react';

type Props = {
    onGridStateChange: (refinedFilters: GridFilterItem[], refinedFiltersLinkOperator: GridLinkOperator) => void,
    filter: Filter
    sprint: Sprint,
    onLeadSelected: (leadId: string) => void,
    selectedSprintId: string,
    unassignedOnly: boolean
}

const ICPLeadList = ({ filter, onLeadSelected, selectedSprintId, unassignedOnly, onGridStateChange, sprint }: Props) => {
    const [pageSize, setPageSize] = useState(10)
    const { useGetIcpLeads, icp, resetLeads } = useICPWizard();
    const { data: paginatedLeads, isLoading, fetchNextPage, hasNextPage, refetch } = useGetIcpLeads(filter.options, filter.searchTerm, pageSize, unassignedOnly, selectedSprintId);
    const { mutate } = useToggleLeadSprint();
    const apiRef = useGridApiRef();

    useEffect(() => {
        if (!isLoading) {
            resetLeads(icp.primaryFilters.options, icp.primaryFilters.searchTerm, pageSize, unassignedOnly, sprint.id);
            refetch({ refetchPage: (page, index) => index === 0 })
        }
    }, [icp])

    const preColumns = [

    ] as GridColDef[];

    const handleGridStateChange = () => {
        //const state = apiRef.current.exportState();

        //if (!state.filter || !state.filter.filterModel) return;

        //onGridStateChange(state.filter.filterModel.items, state.filter.filterModel.linkOperator ?? GridLinkOperator.And)
    }

    const onFilterModelChange = React.useCallback((filterModel: GridFilterModel) => {
        onGridStateChange(filterModel.items, filterModel.linkOperator ?? GridLinkOperator.And)
        // Here you save the data you need from the filter model
        //setQueryOptions({ filterModel: { ...filterModel } });
    }, []);

    return (
        <>
            {isLoading && <LoadingSpinner text="Fetching Leads" />}
            {!isLoading && <LeadDataGridView2
                onFilterModelChange={onFilterModelChange}
                gridFilterItems={icp.refinedFilters}
                gridLinkOperator={icp.refinedFiltersLinkOperator}
                onGridStateChange={handleGridStateChange}
                apiRef={apiRef}
                isLoading={isLoading}
                leadPages={paginatedLeads?.pages}
                selectedLeadIds={[]}
                hasNextPage={hasNextPage === true}
                fetchNextPage={fetchNextPage}
                preColumns={preColumns}
                onSelectionModeChange={() => { }}
            />}
        </>

    )
}

interface CellType {
    row: LeadGridItem
}

export { ICPLeadList };
export default ICPLeadList;